export var MIN_DOMAIN_LENGTH = 5;